import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';

import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import { getUTCDate } from '@/shared/utils/date';
import guid from '@/shared/utils/guid';
import { allocationsTableColumns } from '../../constants';
import Suitability from '../suitability';

interface AllocationsMobileTableProps {
  tableRows: any[];
  openOpportunityDetailsPage: (id: string) => void;
  getRowStatusText: (status: string) => string;
}

const AllocationsMobileTable = ({ tableRows, openOpportunityDetailsPage, getRowStatusText }: AllocationsMobileTableProps) => {
  const TableRow = ({ el }: { el: any }) => {
    return (
      <MobileTableRowWrap key={guid()}>
        <MobileRow>
          <MobileRowTitle>{allocationsTableColumns[0].title}</MobileRowTitle>
          <MobileRowValue isRedirect onClick={() => openOpportunityDetailsPage(el.investmentId)}>
            {el.name}
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{allocationsTableColumns[1].title}</MobileRowTitle>
          <MobileRowValue>{getRowStatusText(el.status)}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{allocationsTableColumns[2].title}</MobileRowTitle>
          <MobileRowValue>{el.subAssetClass ? `${el.assetClass?.name} - ${el.subAssetClass.name}` : el.assetClass?.name}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{allocationsTableColumns[3].title}</MobileRowTitle>
          {el.investorDocsDue && <MobileRowValue>{getUTCDate(new Date(el.investorDocsDue))}</MobileRowValue>}
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{allocationsTableColumns[4].title}</MobileRowTitle>
          <MobileRowValue>
            <FormattingTooltip>{el.minimum}</FormattingTooltip>
          </MobileRowValue>
        </MobileRow>
        <MobileRow>
          <MobileRowTitle>{allocationsTableColumns[5].title}</MobileRowTitle>
          <MobileRowValue>
            <Suitability mr="25" suitability={el.suitability} />
          </MobileRowValue>
        </MobileRow>
      </MobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {tableRows?.length ? (
        tableRows.map((el, index) => {
          return <TableRow el={el} key={index} />;
        })
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default AllocationsMobileTable;
